import { render, staticRenderFns } from "./IframePowerBiPageView.vue?vue&type=template&id=dc48de54&"
import script from "./IframePowerBiPageView.vue?vue&type=script&lang=js&"
export * from "./IframePowerBiPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc48de54')) {
      api.createRecord('dc48de54', component.options)
    } else {
      api.reload('dc48de54', component.options)
    }
    module.hot.accept("./IframePowerBiPageView.vue?vue&type=template&id=dc48de54&", function () {
      api.rerender('dc48de54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/IframePowerBiPageView.vue"
export default component.exports